import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './spacing.module.css';

type Props = {
  height?: number;
} & ComponentProps<'div'>;

export const Spacing = ({ height = 16, className, ...props }: Props) => {
  return <div className={clsx([styles.container, className])} style={{ height }} {...props} />;
};
